"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "SortsV3Controller", {
    enumerable: true,
    get: function() {
        return SortsV3Controller;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _sortsv3service = require("~/services/v3/sorts-v3.service");
const _controllers = require("~/constants/controllers");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let SortsV3Controller = class SortsV3Controller {
    async sortList(context, viewId) {
        return {
            list: await this.sortsV3Service.sortList(context, {
                viewId
            })
        };
    }
    async sortCreate(context, viewId, body, req) {
        const sort = await this.sortsV3Service.sortCreate(context, {
            sort: body,
            viewId,
            req
        });
        return sort;
    }
    async sortUpdate(context, body, viewId, req) {
        const sort = await this.sortsV3Service.sortUpdate(context, {
            sortId: body.id,
            sort: body,
            req,
            viewId
        });
        return sort;
    }
    async sortDelete(context, body, req, viewId) {
        await this.sortsV3Service.sortDelete(context, {
            viewId,
            sortId: body.id,
            req
        });
        return {};
    }
    constructor(sortsV3Service){
        this.sortsV3Service = sortsV3Service;
    }
};
_ts_decorate([
    (0, _common.Get)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/sorts`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/sorts`
    ]),
    (0, _extractidsmiddleware.Acl)('sortList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsV3Controller.prototype, "sortList", null);
_ts_decorate([
    (0, _common.Post)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/sorts`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/sorts`
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('sortCreate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.SortCreateV3Type === "undefined" ? Object : _nocodbsdk.SortCreateV3Type,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsV3Controller.prototype, "sortCreate", null);
_ts_decorate([
    (0, _common.Patch)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/sorts`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/sorts`
    ]),
    (0, _extractidsmiddleware.Acl)('sortUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _nocodbsdk.SortUpdateV3Type === "undefined" ? Object : _nocodbsdk.SortUpdateV3Type,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsV3Controller.prototype, "sortUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        `${_controllers.PREFIX_APIV3_METABASE}/tables/:tableId/views/:viewId/sorts`,
        `${_controllers.PREFIX_APIV3_METABASE}/views/:viewId/sorts`
    ]),
    (0, _extractidsmiddleware.Acl)('sortDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Body)()),
    _ts_param(2, (0, _common.Req)()),
    _ts_param(3, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], SortsV3Controller.prototype, "sortDelete", null);
SortsV3Controller = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _sortsv3service.SortsV3Service === "undefined" ? Object : _sortsv3service.SortsV3Service
    ])
], SortsV3Controller);
